import { PlaneView } from '~/engine/view/views/PlaneView';

/**
 * Sets the CSS cursor shown over the given views: on the parent of each
 * view's canvases and on the viewport container above it, so the value
 * reaches the canvas under the pointer by inheritance wherever it is.
 * Writes nothing when no views are known.
 */
export function setViewportCursorStyle(
    views: readonly PlaneView[] | null | undefined,
    style: string
): void {
    for (const view of views ?? []) {
        const parent = view.get2DCanvas?.parentElement;
        if (!parent) {
            continue;
        }
        parent.style.cursor = style;
        const viewportContainer = parent.closest(
            '[data-viewport-container]'
        ) as HTMLElement | null;
        if (viewportContainer) {
            viewportContainer.style.cursor = style;
        }
    }
}
